export const searchUser = (allUsers, filterWord) => {
  return allUsers.filter((user) =>
    user.email.toLowerCase().includes(filterWord.toLowerCase())
  );
};

export const deleteUser = (allUsers, userId) => {
  return allUsers.filter((user) => user._id !== userId);
};
